import React from 'react';
import { AddressDisplay } from '../AddressDisplay';
import { BasicAddress } from '../AddressDisplay/AddressDisplay';
import { EditAddressButton } from '../EditAddressButton';

export interface OrderDetailsTableProps {
  t: {
    orderDetailsHeader?: string;
    deliveryAddressHeader: string;
    billingAddressHeader: string;
    shippingMethodHeader: string;
    paymentInfoHeader: string;
    edit?: string;
  };
  orderData: {
    shippingAddress: BasicAddress;
    billingAddress: BasicAddress;
    shippingInfoContent?: string;
    paymentInfoContent?: string;
  };
  shippingOriginalUuid?: string;
}

const OrderDetailsTable = ({
  t,
  orderData,
  shippingOriginalUuid,
}: OrderDetailsTableProps) => {
  const {
    shippingAddress,
    billingAddress,
    shippingInfoContent,
    paymentInfoContent,
  } = orderData;

  return (
    <div className="px-6 lg:px-8 py-8 lg:py-10 flex flex-col bg-indigo-pastel rounded text-grey-dark">
      {t.orderDetailsHeader && (
        <h1 className="md:text-[32px] text-2xl font-bold w-full mb-6">
          {t.orderDetailsHeader}
        </h1>
      )}
      <div className=" flex flex-col gap-6 md:flex-row md:justify-between mb-6">
        <div className="md:w-[50%]">
          <div className="flex gap-2 items-center pb-1 lg:pb-2">
            <p className="font-bold text-lg md:text-xl w-fit">
              {t.deliveryAddressHeader}
            </p>
            {shippingOriginalUuid && (
              <EditAddressButton
                shippingOriginalUuid={shippingOriginalUuid}
                label={t.edit || ''}
              />
            )}
          </div>
          <AddressDisplay address={shippingAddress} />
        </div>
        <div className="md:w-[50%]">
          <p className="font-bold text-lg md:text-xl pb-1 lg:pb-2 w-fit">
            {t.billingAddressHeader}
          </p>

          <AddressDisplay address={billingAddress} />
        </div>
      </div>

      <div className=" flex flex-col gap-6 md:flex-row md:justify-between">
        {shippingInfoContent && (
          <div className="md:w-[50%]">
            <p className="font-bold text-lg md:text-xl pb-1 lg:pb-2 w-fit">
              {t.shippingMethodHeader}
            </p>
            <p className="text-base md:text-lg break-all">
              {shippingInfoContent}
            </p>
          </div>
        )}
        {paymentInfoContent && (
          <div className="md:w-[50%]">
            <p className="font-bold text-lg md:text-xl pb-1 lg:pb-2 w-fit">
              {t.paymentInfoHeader}
            </p>
            <p className="text-base md:text-lg break-all">
              {paymentInfoContent}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default OrderDetailsTable;
